// extracted by mini-css-extract-plugin
export default {"RegistryCreate__PhotoUploader":"registry-create__RegistryCreate__PhotoUploader__zd0Wm"};